<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card
          class="pa-5 live-trade-details-card"
          elevation="0"
          :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        >
          <v-row class="no-gutters align-center">
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-text-field
                v-model="search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                solo
                hide-details
                class="mt-0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="2">
              <v-select
                solo
                :items="slots1"
                append-icon="mdi-chevron-down"
                label="Category"
                class="custom-select mt-0"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="3">
              <v-select
                solo
                :items="slots2"
                append-icon="mdi-chevron-down"
                label="Subject"
                class="custom-select mt-0"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    prepend-icon="mdi-calendar"
                    append-icon="mdi-chevron-down"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    solo
                    class="custom-select mt-0"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  class="custom-date-picker"
                  scrollable
                  range
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'"
                    text
                    @click="modal = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    :color="$vuetify.theme.dark ? '#fff' : '#131c29'"
                    text
                    @click="$refs.dialog.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="1">
              <ul class="mt-0 justify-end">
                <li>
                  <span class="">Total Count:</span>
                  <span>0</span>
                </li>
              </ul>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card
                class="pa-0 rounded-0 elevation-0"
                :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
              >
                <v-sheet
                  class="transactionTable depositTabTable registerUserTable"
                  :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
                >
                  <v-data-table
                    :headers="headers"
                    :items="Transaction"
                    :items-per-page="7"
                  >
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      search: "",
      modal: false,
      dialog: false,
      date: ["2022-01-01", "2023-01-01"],
      slots1: ["Lorem Ipsume 1", "Lorem Ipsume 2", "Lorem Ipsume 3"],
      slots2: ["Lorem Ipsume 1", "Lorem Ipsume 2", "Lorem Ipsume 3"],
      headers: [
        { text: "SL", align: "start", value: "SlView" },
        { text: "Category", value: "CategoryView" },
        { text: "Subject", value: "SubjectView" },
        { text: "Email From", value: "EmailFrom" },
        { text: "Email To", value: "EmailTo" },
        { text: "Date & Time", value: "DateTimeView" },
      ],

      Transaction: [
        {},
      ],
    };
  },
  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },
};
</script>
